import DubChampBadge from './DubChampBadge'
import { Card } from './ui/card'

// The default group prize (owner 2026-10-07): bragging rights and the dub
// Champ crown, for any group tournament the owner hasn't put a prize on.
// Shared by the tournament card's Prizes tab and the group's Prizes tab so
// both say the same thing.
export default function BraggingRightsCard({ champNames = [], tournamentName = null, className = '' }) {
  return (
    <Card className={`p-4 ${className}`} data-testid="bragging-rights">
      <div className="flex items-start gap-4">
        <DubChampBadge label="" className="h-12 w-12 flex-shrink-0 justify-center p-0 [&>svg]:h-7 [&>svg]:w-7" />
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-lg">Bragging Rights</h3>
          {tournamentName && (
            <p className="text-sm font-medium text-foreground break-words">{tournamentName}</p>
          )}
          <p className="text-sm text-muted-foreground">
            {champNames.length > 0
              ? `Won by ${champNames.join(' & ')}, this tournament's dub Champ.`
              : "The group's top scorer is crowned dub Champ for this tournament."}
          </p>
        </div>
      </div>
    </Card>
  )
}
